module.exports = __webpack_public_path__ + "img/no_task.dd761ead.png";